// extracted by mini-css-extract-plugin
export default {"densities":"style_densities__2Zazx"};